'use client';

var vi = {
    'Job Search and Recruitment': 'Việc Làm và Tuyển Dụng',
    "Experience VietnamWorks - Vietnam's largest job search application": 'Trải nghiệm VietnamWorks - Ứng dụng tìm việc làm lớn nhất Việt Nam',
    'Install Application': 'Cài Đặt Ứng Dụng',
    Install: 'Cài Đặt',
    'Open App': 'Mở App'
};

export { vi as default };
//# sourceMappingURL=vi.js.map
